import React from "react";
import s from './News.module.css';


export const News =() => {
    return (
        <div>
          News
        </div>
    )
}